import React, {useRef, useState, useCallback, useEffect} from "react";
import DropDownBox from "devextreme-react/drop-down-box";
import {TreeList} from "devextreme-react/tree-list";
import {Column, Pager, Paging, Scrolling, Selection} from "devextreme-react/tree-list";
import {FilterRow} from "devextreme-react/tree-list";
import {Popup} from "devextreme-react/popup";
import {Button} from "devextreme-react/button";
import {PopupTitleWithIcon} from "../popup-title-with-icon/popup-title-with-icon";
import './points-tree.scss'
import StorageService from "../../services/storage.service";
import ObjNameCell, {objNameFilterValue} from "./obj-name-cell";

export default function PopupPointsTreeHook(props) {
  const treeDataSource = props.points
  const selectionMode = props.selectionMode
  const onSelect = props.onSelect
  const onShow = props.onShow
  const showDisabled = props.showDisabled
  const shouldAllowSelectionChange = props.shouldAllowSelectionChange
  const treeRef = props.treeRef

  let treeViewRef = useRef();
  const [treeBoxValue, setTreeBoxValue] = useState([]);
  const treeBoxValueRef = useRef([]);
  const suppressSelectionEventRef = useRef(false);
  const [popupVisible, setPopupVisible] = useState(false)
  treeBoxValueRef.current = treeBoxValue

  useEffect(() => {
      const LocalPointsIds = StorageService.getLocalPoints()
      if (LocalPointsIds) {
          setTreeBoxValue(LocalPointsIds)
      }
  }, [])

  const syncSelection = useCallback((treeView) => {
    try {
        const selectedEmployees = treeView
        onSelect(selectedEmployees)
    } catch (e) {
        onSelect([])
    }

  },[onSelect])

  const syncTreeViewSelection = useCallback(
    (e) => {
      let treeView =
        (e.component.selectItem && e.component) ||
          (treeViewRef.current && treeViewRef.current.instance);
      if (treeView) {
        if (e.value === null) {
          treeView.unselectAll();
        } else {
          let values = e.value || treeBoxValue;
          values &&
          treeView.selectRows(values);
        }

      }

      if (e.value !== undefined) {
        setTreeBoxValue(e.value)
      }
    },
    [treeBoxValue]
  );

  const treeView_itemSelectionChanged = useCallback((e) => {
    if (suppressSelectionEventRef.current) return
    const selectedRows = e.component.getSelectedRowsData(selectionMode)
    if (shouldAllowSelectionChange && !shouldAllowSelectionChange(selectedRows)) {
      suppressSelectionEventRef.current = true
      e.component.selectRows(treeBoxValueRef.current || [], false)
      suppressSelectionEventRef.current = false
      return
    }
    const LocalPointsIds = selectedRows.map((obj) => obj.id)
    setTreeBoxValue(LocalPointsIds)
    StorageService.setLocalPoints(LocalPointsIds)
    syncSelection(selectedRows)
    if (selectionMode === 'single') setPopupVisible(false)
    },
    [syncSelection, selectionMode, shouldAllowSelectionChange]
  );

  const hidePopup = useCallback(() => {
    setPopupVisible(false)
  }, [])

  const handleShow = useCallback(() => {
    setPopupVisible(false)
    if (onShow) onShow()
  }, [onShow])

  return (
    <div>
          <DropDownBox
              id={'ddb'}
            value={treeBoxValue}
            valueExpr="id"
            displayExpr="t"
            placeholder="Выберите точки учёта"
            showClearButton={false}
            dataSource={treeDataSource}
            onValueChanged={syncTreeViewSelection}
            disabled={treeDataSource === null}
            deferRendering={false}
            opened={false}
            onOptionChanged={(e) => {
              if (e.name === 'opened' && e.value === true) {
                e.component.option('opened', false)
                setPopupVisible(true)
              }
            }}
          />
          <Popup
              visible={popupVisible}
              dragEnabled={true}
              hideOnOutsideClick={true}
              showCloseButton={true}
              showTitle={true}
              onHiding={hidePopup}
              maxWidth={'800px'}
              width={'95%'}
              maxHeight={'95%'}
              height={'95%'}
              wrapperAttr={{ class: 'popup-points-tree-wrapper' }}
              titleRender={() => PopupTitleWithIcon('dx-icon-hierarchy', "Выберите", hidePopup)}
          >
              <div className="popup-points-tree">
                  <div className="popup-points-tree__list">
                      <TreeList
                          height="100%"
                          id="tree-list-energoobjects-popup"
                          ref={(el) => {
                              treeViewRef.current = el
                              if (treeRef) treeRef.current = el
                          }}
                          dataSource={treeDataSource}
                          autoExpandAll={true}
                          columnAutoWidth={true}
                          showBorders={true}
                          dataStructure="plain"
                          parentIdExpr="pId"
                          keyExpr="id"
                          onSelectionChanged={treeView_itemSelectionChanged}
                          onNodesInitialized={syncTreeViewSelection}
                          onContentReady={syncTreeViewSelection}
                          showColumnLines={false}
                          filterMode={'fullBranch'}
                      >
                          <FilterRow visible={true} />
                          <Selection mode={selectionMode} recursive={true}/>
                          <Scrolling preloadEnabled={true} mode="virtual" />
                          <Paging
                              enabled={true}
                              defaultPageSize={20} />
                          <Pager
                              showPageSizeSelector={true}
                              allowedPageSizes={"auto"}
                              showInfo={true} />
                          <Column
                              dataField="t"
                              caption="Название"
                              cellComponent={ObjNameCell}
                              calculateCellValue={objNameFilterValue}>
                          </Column>
                          {window.location.hash === '#/energoobjects' &&
                          <Column
                              dataField="askue"
                              width={40}
                              allowFiltering={false}
                              caption=''
                              cellComponent={(props) => {
                                  const askue = props.data.data.askue;
                                  if (askue && props.data.data.id.includes('_')) {
                                      return <i className="dx-icon-chart main-color-light"></i>
                                  }
                                  return (
                                      <></>
                                  );
                              }}
                          />
                          }
                      </TreeList>
                  </div>
                  {selectionMode !== 'single' &&
                  <div className="popup-points-tree__footer">
                      <Button
                          type='default'
                          text="Показать"
                          icon="refresh"
                          disabled={showDisabled || treeBoxValue.length === 0}
                          onClick={handleShow}
                      />
                  </div>
                  }
              </div>
          </Popup>
    </div>
  );
}
